export interface DashboardGuildSummary {
  id: string;
  name: string;
  iconUrl: string | null;
  permissions: {
    isOwner: boolean;
    isAdmin: boolean;
    isModerator: boolean;
  };
}

interface ResolveGuildSelectionOptions {
  requestedGuildId: string | null;
  storedGuildId: string | null;
  defaultGuildId: string | null;
  guilds: DashboardGuildSummary[];
}

export function resolveGuildSelection(options: ResolveGuildSelectionOptions) {
  const availableIds = new Set(options.guilds.map((guild) => guild.id));
  const candidates = [
    options.requestedGuildId,
    options.storedGuildId,
    options.defaultGuildId,
    options.guilds[0]?.id ?? null
  ];

  for (const candidate of candidates) {
    if (candidate && availableIds.has(candidate)) {
      return candidate;
    }
  }

  return null;
}
